module.exports = __webpack_public_path__ + "ida_design_awards_graphic_design_typography_architecture_photography_style_moodboards.jpg?1bdc1a3cbccab2c2790d6aa27a26dc0d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/ida/ida_design_awards_graphic_design_typography_architecture_photography_style_moodboards.jpg
// module id = 65
// module chunks = 0